/**
 * <flash-sale-countdown data-end-ts="1735689600">
 * Cuenta regresiva por tarjeta para sections/ADD-flash-sale.liquid. Cada
 * instancia gestiona su propio temporizador de forma independiente (no
 * depende del id de la sección ni de querySelectorAll globales), así que
 * varias tarjetas — o varias secciones — conviven sin conflicto.
 * Al llegar a cero, elimina la tarjeta ".flash-sale-card" que la contiene,
 * igual que el comportamiento anterior.
 */
(function () {
  if (customElements.get('flash-sale-countdown')) return;

  class FlashSaleCountdown extends HTMLElement {
    connectedCallback() {
      var endTs = parseInt(this.dataset.endTs, 10);
      if (!endTs) return;

      this.endDate = new Date(endTs * 1000);
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    tick() {
      var diff = this.endDate - new Date();

      if (diff <= 0) {
        clearInterval(this.timer);
        var card = this.closest('.flash-sale-card');
        if (card) card.remove();
        return;
      }

      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      this.innerHTML =
        '<div class="count-item"><span class="count-box">' + String(d).padStart(2, '0') + '</span><span class="count-label">Días</span></div>' +
        '<div class="count-item"><span class="count-box">' + String(h).padStart(2, '0') + '</span><span class="count-label">Hrs</span></div>' +
        '<div class="count-item"><span class="count-box">' + String(m).padStart(2, '0') + '</span><span class="count-label">Mins</span></div>' +
        '<div class="count-item"><span class="count-box">' + String(s).padStart(2, '0') + '</span><span class="count-label">Segs</span></div>';
    }
  }

  customElements.define('flash-sale-countdown', FlashSaleCountdown);
})();
